var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between align-items-center chart-header-wrapper"},[_c('p',{staticClass:"m-0 mr-2"},[_vm._t("default")],2),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }